/**
 * JS file for Expanding Text.
 * Used in a custom BB module and in the theme on hard coded pages.
 *
 * Localized vars available as victaulicThemeVars.
 */
 (($) => {

	const victaulicExpandingText = {
		init: () => {
			victaulicExpandingText.initializeToggles();
		},
		initializeToggles: () => {
			$('.fl-rich-text.vtc-expanding-text .js-additional-text').hide();
			$('.fl-rich-text.vtc-expanding-text a.js-toggle').on('click', () => {
				$(this).parents('.vtc-expanding-text').find('.js-toggle').toggle();
			});
		},
	};

	victaulicExpandingText.init();

    $(document).on('click', 'a.js-toggle', (event) => {
      event.preventDefault();
      $('.js-toggle').toggleClass('hide');
    });

})(jQuery);
